import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=c51fcf5e&scoped=true&lang=pug&"
import script from "./PageHero.vue?vue&type=script&lang=js&"
export * from "./PageHero.vue?vue&type=script&lang=js&"
import style0 from "./PageHero.vue?vue&type=style&index=0&id=c51fcf5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51fcf5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51fcf5e')) {
      api.createRecord('c51fcf5e', component.options)
    } else {
      api.reload('c51fcf5e', component.options)
    }
    module.hot.accept("./PageHero.vue?vue&type=template&id=c51fcf5e&scoped=true&lang=pug&", function () {
      api.rerender('c51fcf5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/PageHero.vue"
export default component.exports